import { render } from "./WhiteDownIcon.vue?vue&type=template&id=6399e8a6"
import script from "./WhiteDownIcon.vue?vue&type=script&lang=js"
export * from "./WhiteDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__